import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssessmentForm {
    id: number;
    name: string;
    instructions: Instruction[];
}

export interface Instruction {
    instructionText: string;
    instructionVideoUrl: string;
    stepName: string;
}

export const initialState: AssessmentForm = {
    id: 0,
    name: "",
    instructions: []
};

const assessmentFormSlice = createSlice({
    name: "assessmentForm",
    initialState,
    reducers: {
        setAssessmentForm(state, action: PayloadAction<AssessmentForm>) {
            state.name = action.payload.name;
            state.instructions = action.payload.instructions;
        }
    }
});

export const { setAssessmentForm } = assessmentFormSlice.actions;

export default assessmentFormSlice.reducer;
